import React from 'react'
import { Login } from '../../Components/Login/Login'

export const LoginPage = () => {
  return (
    <Login />
  )
}
